// src/components/forms/pending-orders/PendingOrdersOriginAddress.tsx
// Componente para la sección de Dirección de Origen

import React from 'react'
import type { PendingOrderFormData } from '../../../types/pendingOrdersFormTypes'
import { Input } from '../../ui'
import { FormField } from '../../ui/Form'
import SectionTitle from '../../ui/SectionTitle'
import { MapPinIcon, ChevronDownIcon } from '@heroicons/react/24/outline'

interface PendingOrdersOriginAddressProps {
  formData: PendingOrderFormData
  isExpanded: boolean
  onToggleExpanded: () => void
  onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void
}

export const PendingOrdersOriginAddress: React.FC<PendingOrdersOriginAddressProps> = ({
  formData,
  isExpanded,
  onToggleExpanded,
  onInputChange
}) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow">
      <div 
        className="flex justify-between items-center cursor-pointer"
        onClick={onToggleExpanded}
      >
        <SectionTitle icon={MapPinIcon} noMargin>Dirección de Origen</SectionTitle>
        <ChevronDownIcon className={`w-6 h-6 transform transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`} />
      </div>
      <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 transition-all duration-200 ${isExpanded ? 'mt-4' : 'hidden'}`}>
        <FormField
          label="Nombre completo"
          required
        >
          <Input
            type="text"
            name="origenNombre"
            value={formData.origenNombre}
            onChange={onInputChange}
            readOnly
            mode="view"
          />
        </FormField>
        
        <FormField label="Email">
          <Input
            type="email"
            name="origenEmail"
            value={formData.origenEmail}
            onChange={onInputChange}
            readOnly
            mode="view"
          />
        </FormField>
        
        <FormField
          label="Celular"
          required
        >
          <Input
            type="tel"
            name="origenCelular"
            value={formData.origenCelular}
            onChange={onInputChange}
            readOnly
            mode="view"
          />
        </FormField>
        
        <FormField
          label="País"
          required
        >
          <Input
            type="text"
            name="origenPais"
            value={formData.origenPais}
            onChange={onInputChange}
            readOnly
            mode="view"
          />
        </FormField>
        
        <FormField
          label="Departamento"
          required
        >
          <Input
            type="text"
            name="origenDepartamento"
            value={formData.origenDepartamento}
            onChange={onInputChange}
            readOnly
            mode="view"
          />
        </FormField>
        
        <FormField
          label="Ciudad"
          required
        >
          <Input
            type="text"
            name="origenCiudad"
            value={formData.origenCiudad}
            onChange={onInputChange}
            readOnly
            mode="view"
          />
        </FormField>
        
        <FormField
          label="Dirección"
          required
        >
          <Input
            type="text"
            name="origenDireccion"
            value={formData.origenDireccion}
            onChange={onInputChange}
            readOnly
            mode="view"
          />
        </FormField>
        
        <FormField label="Referencia de dirección">
          <Input
            type="text"
            name="origenReferencia"
            value={formData.origenReferencia}
            onChange={onInputChange}
            mode="edit"
          />
        </FormField>
        
        <FormField label="Nit / CC">
          <Input
            type="text"
            name="origenNit"
            value={formData.origenNit}
            onChange={onInputChange}
            readOnly
            mode="view"
          />
        </FormField>
      </div>
    </div>
  )
}

